"use client";

import { c as _c } from "react/compiler-runtime";
import { CreateDropWaveWrapper } from "@/components/waves/CreateDropWaveWrapper";
import WaveDropsAll from "@/components/waves/drops/wave-drops-all";
import MobileMemesArtSubmissionBtn from "@/components/waves/memes/submission/MobileMemesArtSubmissionBtn";
import PrivilegedDropCreator, { DropMode } from "@/components/waves/PrivilegedDropCreator";
import { ApiDrop } from "@/generated/models/ApiDrop";
import { ApiWave } from "@/generated/models/ApiWave";
import { getHomeFeedRoute } from "@/helpers/navigation.helpers";
import { useAndroidKeyboard } from "@/hooks/useAndroidKeyboard";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { useWave } from "@/hooks/useWave";
import { selectEditingDropId } from "@/store/editSlice";
import { ActiveDropAction, ActiveDropState } from "@/types/dropInteractionTypes";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLayout } from "./layout/LayoutContext";
interface MyStreamWaveChatProps {
  readonly wave: ApiWave;
}
const MyStreamWaveChat: React.FC<MyStreamWaveChatProps> = t0 => {
  const $ = _c(35);
  const {
    wave
  } = t0;
  const router = useRouter();
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const containerRef = useRef(null);
  const [initialDrop, setInitialDrop] = useState(null);
  const [searchParamsDone, setSearchParamsDone] = useState(false);
  const {
    isMemesWave
  } = useWave(wave);
  const editingDropId = useSelector(selectEditingDropId);
  const {
    isApp
  } = useDeviceInfo();
  const {
    getContainerStyle
  } = useAndroidKeyboard();
  const [activeDrop, setActiveDrop] = useState(null);
  let t1;
  let t2;
  if ($[0] !== pathname || $[1] !== router || $[2] !== searchParams) {
    t1 = () => {
      const dropParam = searchParams?.get("serialNo");
      if (dropParam) {
        setInitialDrop(parseInt(dropParam));
        const params = new URLSearchParams(searchParams?.toString() || "");
        params.delete("serialNo");
        const href = params.toString() ? `${pathname}?${params.toString()}` : pathname || getHomeFeedRoute();
        router.replace(href, {
          scroll: false
        });
      } else {
        setInitialDrop(null);
      }
      setSearchParamsDone(true);
    };
    t2 = [searchParams, router, pathname];
    $[0] = pathname;
    $[1] = router;
    $[2] = searchParams;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  const {
    waveViewStyle
  } = useLayout();
  let t3;
  if ($[5] !== waveViewStyle) {
    t3 = waveViewStyle || {};
    $[5] = waveViewStyle;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== getContainerStyle || $[8] !== t3) {
    t4 = getContainerStyle(t3, 128);
    $[7] = getContainerStyle;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const containerStyle = t4;
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setActiveDrop(null);
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== wave) {
    t6 = [wave];
    $[11] = wave;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  useEffect(t5, t6);
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = (drop, partId) => {
      setActiveDrop({
        action: ActiveDropAction.REPLY,
        drop,
        partId
      });
    };
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const onReply = t7;
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = (drop_0, partId_0) => {
      setActiveDrop({
        action: ActiveDropAction.QUOTE,
        drop: drop_0,
        partId: partId_0
      });
    };
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const onQuote = t8;
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = t10 => {
      const {
        drop: drop_1,
        partId: partId_1
      } = t10;
      onReply(drop_1, partId_1);
    };
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const handleReply = t9;
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = t11 => {
      const {
        drop: drop_2,
        partId: partId_2
      } = t11;
      onQuote(drop_2, partId_2);
    };
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  const handleQuote = t10;
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => {
      setActiveDrop(null);
    };
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  const onCancelReplyQuote = t11;
  if (!searchParamsDone) {
    return null;
  }
  let t12;
  if ($[18] !== activeDrop || $[19] !== initialDrop || $[20] !== wave.id) {
    t12 = <WaveDropsAll key={wave.id} waveId={wave.id} onReply={handleReply} onQuote={handleQuote} activeDrop={activeDrop} initialDrop={initialDrop} dropId={null} />;
    $[18] = activeDrop;
    $[19] = initialDrop;
    $[20] = wave.id;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== activeDrop || $[23] !== editingDropId || $[24] !== isApp || $[25] !== wave) {
    t13 = !(isApp && editingDropId) && <div className="tw-mt-auto"><CreateDropWaveWrapper><PrivilegedDropCreator activeDrop={activeDrop} onCancelReplyQuote={onCancelReplyQuote} onDropAddedToQueue={onCancelReplyQuote} wave={wave} dropId={null} fixedDropMode={DropMode.BOTH} /></CreateDropWaveWrapper></div>;
    $[22] = activeDrop;
    $[23] = editingDropId;
    $[24] = isApp;
    $[25] = wave;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== isMemesWave || $[28] !== wave) {
    t14 = isMemesWave && <MobileMemesArtSubmissionBtn wave={wave} />;
    $[27] = isMemesWave;
    $[28] = wave;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== containerStyle || $[31] !== t12 || $[32] !== t13 || $[33] !== t14) {
    t15 = <div ref={containerRef} className="tw-w-full tw-flex tw-flex-col tw-overflow-y-auto tw-overflow-x-hidden lg:tw-scrollbar-thin tw-scrollbar-thumb-iron-500 tw-scrollbar-track-iron-800 desktop-hover:hover:tw-scrollbar-thumb-iron-300 scroll-shadow tw-flex-grow" style={containerStyle}>{t12}{t13}{t14}</div>;
    $[30] = containerStyle;
    $[31] = t12;
    $[32] = t13;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  return t15;
};
export default MyStreamWaveChat;